import _ from 'lodash';
import createjs from 'createjs-collection';

import * as fJS from './../cjsRoot/fJS';
import { cjsItem } from './../cjsRoot/cjsBase';
import { cjsDnD } from './cjsDnD';
import { cjsPoint } from './../cjsObjects/cjsPoint';

export class cjsRotate extends cjsDnD {
  _aid;
  _rotateByClick;
  _angleRotate;
  _offMove;

  constructor(obj) {
    super(obj);
    this._aid = 0;
  }

  create() {
    super.create();

    if (this.block !== true)
      this._container.listener.c = this._container.on('click', this.stageMouseClick, null, false, {
        engine: this,
        cjsStage: this._stage,
      });

    this._rotateByClick = this.otherProperty.rotateByClick === true ? true : false;
    this._angleRotate = Number.isInteger(this.otherProperty.angleRotate) !== true ? 45 : this.otherProperty.angleRotate;
    this._offMove = this.otherProperty.rotateByClick === true ? true : false;

    if (this._rotateByClick === true) {
      this.regX = this.width / 2;
      this.regY = this.height / 2;
      this.x += this.regX;
      this.y += this.regY;
    }
  }

  ShowHidePoints(show) {
    for (let i in this._points) {
      if (typeof this._points[i] !== 'object' || this._points[i] === null) continue;

      this._points[i].visible = this._points[i].alwaysShow === true ? true : typeof show === 'boolean' ? show : null;

      this._container.setChildIndex(this._points[i].shape, this._container.getNumChildren() - 1);

      this._container.updateCache();
    }
  }

  pointMouseDown(e, data) {
    let stage = data.cjsStage,
      engine = data.engine,
      point = engine.points[data.idPoint];

    stage.resetCheckStatus();
    if (stage.mousedown !== false && engine.block !== false && point.block !== false) {
      e.stopPropagation();
      return false;
    }
    engine._mousedown = true;
    stage.mousedown = true;

    let globalPoint = point.shape.parent.localToGlobal(point.regs.regX, point.regs.regY),
      localPoint = engine.container.globalToLocal(globalPoint.x, globalPoint.y),
      previousRegX = engine.container.regX,
      previousRegY = engine.container.regY;

    engine._container.regX = localPoint.x;
    engine._container.regY = localPoint.y;

    let matrix = new createjs.Matrix2D();
    matrix.appendTransform(
      engine.container.x,
      engine.container.y,
      engine.container.scaleX,
      engine.container.scaleY,
      engine.container.rotation,
      engine.container.skewX,
      engine.container.skewY,
      -(localPoint.x - previousRegX),
      -(localPoint.y - previousRegY)
    );
    matrix.decompose(engine.container);

    let gp = engine.container.localToGlobal(point.regs.regX, point.regs.regY),
      pt = { x: gp.x - stage.offset.x, y: gp.y - stage.offset.y };
    engine.aid =
      Math.atan2(e.stageY - stage.offset.y - pt.y, e.stageX - stage.offset.x - pt.x) * (180 / Math.PI) -
      engine.rotation;
    point._listener.pm = point.shape.on('pressmove', engine._pointMouseMove, null, false, {
      engine: engine,
      cjsStage: stage,
      idPoint: point.id,
    });

    e.stopPropagation();
  }

  _pointMouseMove(e, data) {
    let stage = data.cjsStage,
      engine = data.engine,
      point = engine.points[data.idPoint];

    if (stage.mousedown !== true) {
      e.stopPropagation();
      return false;
    }
    let pt = engine.container.localToGlobal(point.regs.regX, point.regs.regY),
      aid = (Math.atan2(e.stageY - pt.y, e.stageX - pt.x) * 180) / Math.PI;

    engine.rotation = aid - engine.aid;
  }

  pointMouseUp(e, data) {
    let stage = data.cjsStage,
      engine = data.engine,
      point = engine.points[data.idPoint];
    if (stage.mousedown !== true) {
      e.stopPropagation();
      return;
    }

    stage.mousedown = false;
    engine._mousedown = false;
    point.shape.off('pressmove', point._listener.pm);
    if (engine.thrown !== false) {
      engine.thrown.rotation = engine.rotation;
    }

    e.stopPropagation();
  }

  stageMouseDown(e, data) {
    console.log('cjsRotate: DOWN');
    if (data.engine._offMove === false) {
      super.stageMouseDown(e, data);
    }
  }

  stageMouseClick(e, data) {
    console.log('cjsRotate CLICK');
    let engine = data.engine,
      stage = data.cjsStage;

    if (engine._rotateByClick === false) {
      for (let gr in stage.groups) {
        for (let i in stage.groups[gr].items) {
          if (stage.groups[gr].items[i].block === true) continue;

          stage.groups[gr].items[i].ShowHidePoints(false);
        }
      }

      engine.ShowHidePoints(true);
      return false;
    }
    if (engine.block == true) {
      e.stopPropagation();
      return false;
    }

    engine.rotation += engine._angleRotate;
    if (engine.rotation === -0 || engine.rotation === -360) {
      engine.rotation = 0;
    }
    if (engine.rotation >= 360) {
      engine.rotation -= 360;
    }
    if (engine.rotation < 0) {
      engine.rotation += 360;
    }

    stage.sounds.play(engine.idGroup + '.' + engine.id + '.click');
    console.log(engine.id + ' ' + engine.rotation);

    if (stage.autoCheckAllCorrect === true && cjsRotate.checkGameAction.call(this, stage, false) === true) {
      stage._mixins.$store.dispatch('checkGame');
    }
    e.stopPropagation();
  }

  stageMouseUp(e, data) {
    console.log('cjsRotate: UP');
    if (data.engine._offMove === false) {
      super.stageMouseUp(e, data);
    }
  }

  _stageMouseMove(e, data) {
    let engine = data.engine,
      stage = data.cjsStage;
    if (stage.mousedown !== true || engine._mousedown !== true) {
      e.stopPropagation();
      return false;
    }

    super._stageMouseMove(e, data);

    if (engine.thrown !== false) {
      engine.thrown.rotation = engine.rotation;
    }
  }

  isEqual(obj1, obj2) {
    let equal = true;
    for (let i in obj1) {
      if (i !== 'rotation') equal = obj1[i] !== obj2[i] ? false : equal;
      else {
        equal =
          Math.abs(obj1[i] - obj2[i]) > this._stage.defConfig.rotate.tolerance &&
          Math.abs(360 - Math.abs(obj1[i] - obj2[i])) > this._stage.defConfig.rotate.tolerance
            ? false
            : equal;
      }
    }
    for (let i in obj2) {
      if (i !== 'rotation') equal = obj1[i] !== obj2[i] ? false : equal;
      else {
        equal =
          Math.abs(obj1[i] - obj2[i]) > this._stage.defConfig.rotate.tolerance &&
          Math.abs(360 - Math.abs(obj1[i] - obj2[i])) > this._stage.defConfig.rotate.tolerance
            ? false
            : equal;
      }
    }
    return equal;
  }

  set aid(v) {
    this._aid = v;
  }
  get aid() {
    return this._aid;
  }
}

cjsRotate.checkGameAction = function(stage, droped) {
  console.log('cjsRotate CHECK');
  let offMove = false;
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      offMove = item._offMove === true ? true : offMove;
    }
  }

  if (offMove === false) {
    return cjsDnD.checkGameAction(stage, droped);
  }

  let isCorrect = true;
  for (let gr in stage.groups) {
    for (let i in stage.groups[gr].items) {
      let item = stage.groups[gr].items[i];
      if (item.block == true) {
        continue;
      }
      for (let c = 0; c < item.correct.length; c++) {
        let correct =
          item.rotation == item.correct[c].rotation ||
          (item.rotation == 0 && item.correct[c].rotation == 360) ||
          (item.rotation == 360 && item.correct[c].rotation == 0);
        isCorrect = correct == false ? false : isCorrect;
        if (correct == true && stage.correctBlock == true) {
          item.block = true;
        }
      }
    }
  }

  return isCorrect;
};
